<form [formGroup]="ClaimForm" (ngSubmit)="save()">
  <div class="main-box">
    <div
      class="header-box d-flex flex-wrap w-100 justify-content-between row-gap-2"
    >
      <div class="d-flex flex-wrap">
        <div class="back-btn" (click)="goBack()">
          <img
            class="back-btn-img"
            src="../../../assets/Krid/img/back-btn.svg"
            alt=""
          />
        </div>
        <h2 class="ms-4">
          <span class="cursor-pointer" (click)="goBack()">
            Claim Workflow &nbsp;</span
          >
          /
          {{ labelConstants.ClaimByProjectheader }}
          <span mb-2 [ngClass]="{ 'locked-text ms-2 text-danger': isLocked }">{{
            +isLocked ? commonLabelConstants.Locked : ""
          }}</span>
          <span
            [title]="commonLabelConstants.ViewPermission"
            *ngIf="!havePermission"
          >
            <i class="ms-2 fa fa-eye"> </i>
          </span>
        </h2>
      </div>
      <div class="d-flex flex-wrap">
        <ng-select
          [ngClass]="getStatus(claimWorkFlowItemStatus)"
          [disabled]="isLocked || !havePermission"
          [items]="claimWorkFlowItemStatusList"
          [(ngModel)]="claimWorkFlowItemStatus"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Change status of form"
          bindLabel="value"
          bindValue="id"
          class="ms-2 w-200 claimWorkFlowStatus"
          (change)="claimWorkFlowItemStatusChange($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            <span title="{{ item.value }}">{{ item.value }}</span>
          </ng-template>
        </ng-select>
        <button
          type="button"
          class="btn btn-primary-datalist ms-3"
          (click)="export()"
          *ngIf="projectList?.length > 0"
        >
          <i class="fa-solid fa-download"></i>
          <span class="hidebuttonName"> EXPORT</span>
        </button>
      </div>
    </div>
    <div class="form-heading">
      <h3>{{ labelConstants.ClaimByProjectheader }}</h3>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
      <div class="claim-table">
        <div class="table-container">
          <div class="table-responsive">
            <app-loader
              [count]="10"
              [appearance]="'line'"
              [isLoading]="isLoading"
            >
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ labelConstants.projectName }}</th>
                    <th
                      *ngFor="let item of projectList"
                      class="equal-width-col"
                    >
                      {{ item.projectName }}
                    </th>
                    <th>{{ labelConstants.Total }}</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Staffing Costs Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalEligibleStaffingCosts }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      £
                      {{
                        project?.staffingCost
                          | customCurrency : env.CurrencyFormat ?? 0
                      }}
                    </td>
                    <td>
                      <span
                        [ngClass]="{
                          'red-text': staffingCost < 0
                        }"
                      >
                        £
                        {{
                          staffingCost
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- EPW Unconnected Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalEPWUnConnected }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.epwUnConnected < 0
                        }"
                      >
                        £
                        {{
                          project?.epwUnConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': epwUnConnected < 0 }">
                        £
                        {{
                          epwUnConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- EPW Connected Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalEPWConnected }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.epwConnected < 0
                        }"
                      >
                        £
                        {{
                          project?.epwConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': epwConnected < 0 }">
                        £
                        {{
                          epwConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Subcontractor Unconnected Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalSubContractorUnConnected }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.subContractorUnConnected < 0
                        }"
                      >
                        £
                        {{
                          project?.subContractorUnConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span
                        [ngClass]="{
                          'red-text': subContractorUnConnected < 0
                        }"
                      >
                        £
                        {{
                          subContractorUnConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Subcontractor Connected Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalSubContractorConnected }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.subContractorConnected < 0
                        }"
                      >
                        £
                        {{
                          project?.subContractorConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span
                        [ngClass]="{
                          'red-text': subContractorConnected < 0
                        }"
                      >
                        £
                        {{
                          subContractorConnected
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Software Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalSoftware }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span [ngClass]="{ 'red-text': project?.software < 0 }">
                        £
                        {{
                          project?.software
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': software < 0 }">
                        £
                        {{
                          software | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Data Licence Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalDataLicence }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.dataLicence < 0
                        }"
                      >
                        £
                        {{
                          project?.dataLicence
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': dataLicence < 0 }">
                        £
                        {{
                          dataLicence | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Cloud Computing Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalCloudComputing }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.cloudComputing < 0
                        }"
                      >
                        £
                        {{
                          project?.cloudComputing
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': cloudComputing < 0 }">
                        £
                        {{
                          cloudComputing
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Consumable Item Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.totalConsumableItem }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text': project?.consumableItem < 0
                        }"
                      >
                        £
                        {{
                          project?.consumableItem
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': consumableItem < 0 }">
                        £
                        {{
                          consumableItem
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>
                  <!--Utility Row-->
                  <tr>
                    <td class="th-back">{{ labelConstants.utilityCost }}</td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{ 'red-text': project?.utilityCost < 0 }"
                      >
                        £
                        {{
                          project?.utilityCost
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span [ngClass]="{ 'red-text': utilityCost < 0 }">
                        £
                        {{
                          utilityCost | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- PaymentsToClinicalTrialParticipants Row -->
                  <tr>
                    <td class="th-back">
                      {{ labelConstants.paymentsToClinicalTrialParticipants }}
                    </td>
                    <td
                      *ngFor="
                        let project of ClaimByProjectList?.length
                          ? ClaimByProjectList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span
                        [ngClass]="{
                          'red-text':
                            project?.paymentsToClinicalTrialParticipants < 0
                        }"
                      >
                        £
                        {{
                          project?.paymentsToClinicalTrialParticipants
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                    <td>
                      <span
                        [ngClass]="{
                          'red-text': paymentsToClinicalTrialParticipants < 0
                        }"
                      >
                        £
                        {{
                          paymentsToClinicalTrialParticipants
                            | customCurrency : env.CurrencyFormat ?? 0
                        }}
                      </span>
                    </td>
                  </tr>

                  <!-- Project Totals Row -->
                  <tr>
                    <th>{{ labelConstants.Total }}</th>
                    <td
                      *ngFor="
                        let total of ProjectWiseList?.length
                          ? ProjectWiseList
                          : projectList
                      "
                      class="equal-width-col"
                    >
                      <span [ngClass]="{ 'red-text': total?.total < 0 }">
                        <b
                          >£
                          {{
                            total?.total
                              | customCurrency : env.CurrencyFormat ?? 0
                          }}</b
                        >
                      </span>
                    </td>
                    <td class="equal-width-col">
                      <span [ngClass]="{ 'red-text': finalTotal < 0 }">
                        <b
                          >£
                          {{
                            finalTotal ?? 0
                              | customCurrency : env.CurrencyFormat ?? 0
                          }}
                        </b>
                      </span>
                    </td>
                  </tr>

                  <!-- Amount of the above that is QIA Row -->
                  <tr>
                    <th>
                      <div
                        class="d-flex align-items-center"
                      >
                        {{ labelConstants.ProjectAmount }}
                        <mat-icon
                          class="info-icon"
                          title="Click to preview tooltip"
                          (click)="opanPreviewModal(13, 'Claim By Project')"
                          >lightbulb_outline</mat-icon
                        >
                      </div>
                    </th>
                    <td *ngFor="let projectRec of projectList; let i = index">
                      <!-- <input
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{0,4}).*/, '$1');"
                          type="text"
                          placeholder="Enter value for {{
                            projectRec.projectName
                          }}"
                          [formControlName]="'ProjectAmount_' + i"
                          class="form-control"
                        /> -->

                      <div class="summary-input ProjectAmount">
                        <div class="input-group">
                          <span class="input-group-text">£</span>
                          <input
                            class="form-control"
                            [formControlName]="'ProjectAmount_' + i"
                            maxlength="14"
                            placeholder="Enter value for {{
                              projectRec.projectName
                            }}"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{0,2}).*/, '$1');"
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="input-group ProjectAmount">
                        <span class="input-group-text">£</span>
                        <input
                          [ngClass]="{ 'red-text': Projecttotal < 0 }"
                          type="text"
                          class="form-control"
                          [placeholder]="Projecttotal ? Projecttotal : 0"
                          formControlName="Projecttotal"
                          [value]="
                            Projecttotal
                              | customCurrency : env.CurrencyFormat ?? 0
                          "
                          readonly
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </app-loader>
          </div>
        </div>
        <div class="submit-box mx-auto text-center d-block">
          <button
            [disabled]="isLocked || !havePermission"
            type="submit"
            class="btn btn-primary w-25"
          >
            {{ commonLabelConstants.Save }}
          </button>
        </div>
      </div>
    </app-loader>
  </div>
</form>
